$(document).ready( function() {

	// Add style to buttons that belong to general modules
	$('.securityContent').find('[type=submit]').attr('class','submit');
	$('#servicelink').find('[type=submit]').attr('class','submit');

	//html5 placeholder attribute is not supported by a few browsers (including IE < 9)
	//jQuery fix for this issue using $('input[placeholder]')
	if (!supportsInputPlaceholder()) {
		$('[placeholder]').focus(function() {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('placeholder');
			}
		}).blur(function() {
			var input = $(this);
			if (input.val() == '' || input.val() == input.attr('placeholder')) {
				input.addClass('placeholder');
				input.val(input.attr('placeholder'));
			}
		}).blur().parents('form').submit(function() {
			$(this).find('[placeholder]').each(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			});
		});
		// for input fields of type password the type must be changed to text so that the placeholder is legible
		$("input[type=password]").each(function() {
			var elementID, placeholder;
			var placeholder = $(this).attr('placeholder');
			if (placeholder) {
				elementID = $(this).attr('id');
				// change input type so that the text is displayed
				document.getElementById(elementID).type = 'text';
				$(this).focus(function() {
					// change input type so that password is not displayed
					document.getElementById(elementID).type = 'password';
				});
				$(this).blur(function() {
					if ($(this).val() == '' || $(this).val() == placeholder) {
						document.getElementById(elementID).type = 'text';
					}
				});
			}
		});
	}

	// https://incx.nl/single?id=202706&iid=163858
	// $.ajax({
	//     type: 'POST',
	//     url: '/ajax/log_visit?l='+window.location.href+'&sr='+window.outerWidth + 'x'+ window.outerHeight
	// });
});

// Detect browser support for attribute placeholder in input element
// IN:
//UIT: boolean - 'true' if browser supports placeholder text in input
function supportsInputPlaceholder() {
	var i = document.createElement('input');
	return 'placeholder' in i;
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
